import React from 'react'
import '../App.css'
import { ArrowUp } from 'react-feather'
import { Home } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { AiFillCar  } from "react-icons/ai"
import { Link } from 'react-router-dom'
import { Mail } from 'react-feather'

export default function Gita(props) {

    let navigate = useNavigate()  

    return (
        <div className="App">
            <div className='row textDescGita'>
                <div className='col-sm-12'>{props.title}</div>            
            </div>
            <div className='row border-top'>
                <div className='col'>    
                    <div className='row textGita'>
                        <div className='col'><b>Quota: </b></div>
                        <div className='col'>{props.quota}</div>
                    </div>
                    <div className='row textGita'>
                        <div className='col'><b>Dislivello: </b></div>
                        <div className='col'>{props.dislivello}</div>
                    </div>     
                    <div className='row textGita'>
                        <div className='col'><b>Difficoltà: </b></div>
                        <div className='col'>{props.difficolta}</div>
                    </div>
                </div>
                <div className='col textStart px-3'>
                    <span><AiFillCar /></span><br />
                    {props.start}
                </div>
            </div>
            <div className="gita-footer">
                <Link 
                    to="/contact" 
                    state={{ subject: props.title }} 
                    className="gita-action-link"
                >
                    <span>Hai fatto questa escursione? Scrivici </span><Mail size={16} /> 
                </Link>
            </div>
            <div className='row textGita border-top pt-2 pb-2'>
                <div className='col-sm-12'>{props.descrizione}</div>            
            </div>
            <div className='row border-top textTitleFoto'>
                <div className='col'>
                {props.foto.map((item, index) => (
                  <div key={index} className=' border-bottom'>
                    {item.desc}<br></br>
                    <img src={require('../img/' + item.path)} alt={item.desc} className='pictureResize'/>
                    <p className='pt-1'><HashLink to="#top"><ArrowUp /></HashLink>
                    <span className='ps-4 pe-4'></span>
                    <Home onClick={() => navigate('/')}/></p>                   
                  </div>
                ))}                
                </div>
            </div>
            <div className='row textGita border-top'></div>
        </div>
    )   
}
